function initializeArray(size: number): boolean[] {
  const values: boolean [] = [];

  for (let i = 0; i < size; i += 1) {
    values.push(false);
  }

  return values;
}

export default initializeArray;
